import { useDispatch, useSelector } from "react-redux";
import { setNextState } from "../../store/reducers/progressionReducer";
import React, { useEffect } from "react";
import styles from "./Controls.module.css";
import { gsap } from "gsap"
import { pushEvent } from "../../gtm";

export default function Controls() {
    const dispatch = useDispatch();
    const nextState = useSelector((state) => state.progression.nextState);
    const currentModule = useSelector((state) => state.progression.currentModule);
    const activeCamera = useSelector((state) => state.progression.activeCamera);


    useEffect(() => {
        const isMobile = window.innerWidth <= 768;
        if (activeCamera == "MainCamera") {
            if (isMobile && currentModule !== "none") {
                gsap.to(`.${styles.controls}`, {
                    opacity: 0,
                    duration: 1,
                    ease: "power2.out",
                })
            }
            else {
                gsap.to(`.${styles.controls}`, {
                    opacity: 1,
                    duration: 1,
                    ease: "power2.out",
                })
            }
        }
    }, [currentModule, activeCamera])

    const handleNavClick = (state, section) => {
        dispatch(setNextState(state));
        pushEvent('main_nav', { section });
    };

    return (
        <div className={styles.controls}>

            <nav className={styles.interestPoints}>
                <button onClick={() => handleNavClick("TechnologyHub", "Technology Hub")} className={nextState == "TechnologyHub" && styles.selected}>
                    Technology Hub
                </button>
                <button onClick={() => handleNavClick("OptometryLab", "Optometry Lab")} className={nextState == "OptometryLab" && styles.selected}>
                    Optometry Lab
                </button>

                <button onClick={() => handleNavClick("ServiceCenter", "Services Center")} className={nextState == "ServiceCenter" && styles.selected}>
                    Services Center
                </button>


                <button onClick={() => handleNavClick("LdCenter", "L&D Center")} className={nextState == "LdCenter" && styles.selected}>
                    L&D Center
                </button>
            </nav>

        </div>
    );
}
